import script from "./ResolveTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ResolveTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ResolveTemplate.vue?vue&type=style&index=0&id=9d3860ee&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\刘正希\\Desktop\\知谦\\zq\\webside\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d3860ee"]])

export default __exports__